import moment from 'moment'

// export fromThisDate
export const fromThisDate = (value) => {
  return moment(value).startOf('second').fromNow()
}
